<template>
  <div :class="'login ' + (loaded ? 'show-dashboard' : '')">
    <div class="left-con"></div>

    <div class="right-con">
      <div class="login-con">
        <div class="login-card">
          <div class="login-card-head">
            <p class="head-title">循电-充电桩管理系统</p>
            <p class="head-remark">WELCOME TO XD MANAGEMENT SYSTEM.</p>
          </div>

          <div class="login-card-body">
            <el-form class="login-form" autocomplete="off" :model="loginForm">
              <el-form-item prop="username">
                <div class="login-form-group">
                  <div class="input-left"></div>
                  <i class="el-icon-s-promotion input-right"></i>
                  <div class="login-form-group">
                    <el-input name="username" v-model="loginForm.username" placeholder="username" />
                  </div>
                </div>
              </el-form-item>

              <el-form-item prop="password">
                <div class="login-form-group">
                  <div class="input-left"></div>
                  <i class="el-icon-s-marketing input-right"></i>
                  <el-input
                    name="password"
                    type="password"
                    v-model="loginForm.password"
                    @keyup.enter.native="handleLogin"
                    placeholder="password"
                  />
                </div>
              </el-form-item>

              <div class="foot-btn">
                <el-button
                  :loading="loading"
                  @click.native.prevent="handleLogin"
                  type="primary"
                  icon="el-icon-bottom"
                  circle
                ></el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loaded: false,
      loading: false,

      loginForm: {
        username: 'admin',
        password: '123456',
        loading: false
      }
    }
  },

  mounted() {
    setTimeout(() => {
      this.loaded = true
    }, 100)
  },

  methods: {
    handleLogin() {
      this.loading = true

      this.$store
        .dispatch('adminLogin', this.loginForm)
        .then(() => {
          this.loading = false
          this.$router.push({ path: '/' })
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss">
.login {
  position: relative;
  top: 0;
  width: 100%;
  height: 100vh;
  opacity: 0;
  transition: all 2s ease-in-out;

  .left-con {
    position: absolute;
    top: 0;
    left: 0;
    width: 30%;
    height: 100%;
    background-position: center;
    background-size: cover;
    background-image: url('../../assets/login/left_bg.png');

    .logo {
      margin-top: 10%;
      text-align: center;

      img {
        width: 150px;
        height: 150px;
      }
    }
  }

  .right-con {
    position: absolute;
    top: 0;
    right: 0;
    width: 70%;
    height: 100%;
    background-image: url('../../assets/login/right_bg.png');
    background-size: cover;

    .login-con {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 33%;
      text-align: center;
      transform: translateX(-50%) translateY(-50%);
    }

    .login-card {
      position: relative;
      font-size: 14px;

      .login-card-head {
        p {
          display: inline-block;
          margin: 0;
          width: 100%;
        }

        .head-title {
          height: 26px;
          font-size: 20px;
          line-height: 26px;
          color: var(--color-primary);
        }

        .head-remark {
          margin-top: 10px;
          height: 20px;
          font-size: 12px;
          line-height: 20px;
          color: #555;
        }
      }

      .login-card-body {
        padding-top: 30px;

        .login-form {
          padding: 10px 0 0;

          .login-form-group {
            display: flex;
            position: relative;
            width: 100%;
            font-size: 12px;

            .input-left {
              position: absolute;
              top: 50%;
              left: 0;
              z-index: 1;
              width: 2px;
              height: 16px;
              background: var(--color-primary);
              transform: translateY(-50%);
            }

            .input-right {
              position: absolute;
              top: 50%;
              right: 0;
              z-index: 1;
              font-size: 16px;
              color: #c5c6c6;
              transform: translateY(-50%);
            }

            .el-input {
              position: relative;

              .el-input__inner {
                padding: 0 40px 0 25px;
                border-color: #9b9c9c;
                border-radius: 0;
                border-top: 0;
                border-left: 0;
                border-right: 0;
              }
            }
          }

          .foot-btn {
            position: relative;
            padding-top: 30px;
            height: 75px;
            font-size: 12px;

            .el-button {
              margin-top: 0;
              padding: 0;
              width: 40px;
              height: 40px;
              line-height: 40px;
              transition: all 0.3s ease-in-out;

              &:hover {
                margin-top: 5px;
              }
            }
          }
        }
      }
    }
  }
}

.login.show-dashboard {
  opacity: 1;
  transition: opacity 1s ease-in-out;
}

@keyframes autofill {
  to {
    color: #666;
    background: transparent;
  }
}

input:-webkit-autofill {
  animation-name: autofill;
  animation-fill-mode: both;
}
</style>
